@if (lastUpdatedTrafficTime) {
  <div class="traffic_alert alert" role="alert">
    <div>
      <img src="./assets/images/info.png" alt="info"/>
    </div>
    <div class="msg">Traffic alerts last updated: {{lastUpdatedTrafficTime | date:'d MMM y, h:mma'}}</div>
    <div>
      <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">
        <div aria-hidden="true">&times;</div>
      </button>
    </div>
  </div>
}